import { createContext, useContext } from 'react';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';
import { IRequestedStudy } from '@vivli/features/data-requests/infrastructure/interface';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';
import { IUser } from '@vivli/shared/infrastructure/interface';

interface IDatasetContext {
    study: IStudy;
    //the study as it exists within the data request we came from - null when
    //not in a data request context, and until the data request has loaded
    requestedStudy: IRequestedStudy;
    requestedStudyDownloadableIpdPackageId: string;
    showDownload: boolean;
    user: IUser;
    assignedAppType: AssignedAppTypeEnum;
    isLanding: boolean;
}

export const DatasetContext = createContext<IDatasetContext>(null);

export const useDatasetContext = () => useContext(DatasetContext);
